import { CatalogSectionPage } from "./CatalogSectionFamilyPage";

const CatalogSectionFamily = () => {
	return <CatalogSectionPage />;
};
export default CatalogSectionFamily;
